import { Component, Input } from "@angular/core";

import { WarningLink, WarningSettings } from "./nms-warning.models";

/**
 * Componente responsável pela renderização de warnings.
 */
@Component({
    selector: "nms-warning",
    templateUrl: "./nms-warning.component.html",
    styleUrls: ["./nms-warning.component.scss"]
})
export class NmsWarningComponent {
    /** Warnings e suas configurações de exibição */
    @Input() warningSettings: WarningSettings;

    public hasWarningsToShow(warnings: Array<WarningLink>): boolean {
        return warnings.some(warning => warning.show);
    }

}
